import { Image, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import thumbUpImagePath from "@src/appV2/lib/assets/images/cbh-wrapped/thumb-up.png";

import { Button } from "../../../components/Button";
import { PageFooterWrapper } from "../../../components/PageFooterWrapper";
import { InsightContentWrapper } from "../InsightContentWrapper";

// eslint-disable-next-line no-restricted-syntax
const TITLE_COLOR = "#7F006C";

interface EndContentProps {
  onFinished: () => void;
}

export function EndContent(props: EndContentProps) {
  const { onFinished } = props;

  return (
    <>
      <InsightContentWrapper>
        <Text
          semibold
          variant="h1"
          sx={(theme) => ({
            color: TITLE_COLOR,
            marginTop: theme.spacing(5),
          })}
        >
          Amazing job!
        </Text>

        <Text variant="h5" sx={(theme) => ({ color: theme.palette.text.secondary })}>
          You accomplished a lot! Now let&apos;s make this year even better!
        </Text>
      </InsightContentWrapper>
      <PageFooterWrapper>
        <Stack direction="column" spacing={7} sx={{ alignItems: "center" }}>
          <Image src={thumbUpImagePath} alt="Thumb up" />

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              onFinished();
            }}
          >
            Finished!
          </Button>
        </Stack>
      </PageFooterWrapper>
    </>
  );
}
